import { useEffect, useState } from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Card, Col, Form, Row, Tabs } from "react-bootstrap";
import { Footer } from "../../Footer";
import DoughnutChart from "../Outer/DoughnutChart";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { GetRefreshToken, GetToken, RemoveRefreshToken } from "../../utils/helper/helper";
import { Link, useNavigate } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import { GetInvoiceDetails, GetNotificationMes, OragnizationGetRecent, OragnizationGetTotal, SubscriptionDataFilterByDate, UserGetTotal, GetSubscriptionCount, UserAllData } from "../../redux/auth-reducer/auth-service";
import Tab from 'react-bootstrap/Tab';
import dayjs from "dayjs";
import { DatePicker } from "rsuite";
import { Chart } from "chart.js";
import { ChartAdd } from "../Outer/ChartAdd";
import DoughnutChart2 from "../Outer/DoughnutChart2";

function Dashboard() {
    const [data, setData] = useState(false);
    const navigate = useNavigate();
    const [apiData, setApiData] = useState([]);
    const [totalOrgData, setTotalOrgData] = useState([]);
    const [totalUserData, setTotalUserData] = useState([]);
    const [notificationMes, setNotificationMes] = useState([]);
    const [itemData, setItemData] = useState([]);
    const [itemLastData, setItemLastData] = useState([]);
    const [apiDataInvoice, setApiDataInvoice] = useState([]);
    const [startAuctionDate, setStartAuctionDate] = useState("01/01/2024 ");
    // const [startAuctionDate, setStartAuctionDate] = useState();
    const [endAuctionDate, setEndAuctionDate] = useState(dayjs(new Date()).format("MM/DD/YYYY"));
    const [dataSubscription, setDataSubscription] = useState();
    const [subscriptionCount, setSubscriptionCount] = useState();
    const [key, setKey] = useState('Amount');


    useEffect(() => {
        const isAuth = localStorage.getItem('role');
        if (isAuth == 'Web Admin') {

        } else {
            navigate("/Login")
        }

    }, [])
    const getDetails = localStorage?.getItem("role")
    useEffect(() => {
        let Token = GetToken()
        if (!Token) {
            navigate('/Login')
        }

    }, [])
    function sidebarfun() {
        setData(!data)
    }
    useEffect(() => {
        const GetRecentData = async () => {
            await OragnizationGetRecent().then((res) => {
                setApiData(res?.data)
            })
        }
        GetRecentData()
    },
        []);

    useEffect(() => {
        const GetRecentDataInvoice = async () => {
            await GetInvoiceDetails().then((res) => {
                setApiDataInvoice(res?.data?.data?.dataList);

            })
        }
        GetRecentDataInvoice()
    },
        []);

    useEffect(() => {
        const GetTotalData = async () => {
            await OragnizationGetTotal().then((res) => {
                setTotalOrgData(res?.data)

            })
        }
        GetTotalData()
    },
        []);

    useEffect(() => {
        const GetTotalUser = async () => {
            await UserGetTotal().then((res) => {
                setTotalUserData(res?.data)

            })
        }
        GetTotalUser()
    },
        [])

    useEffect(() => {
        const NotificationMessageFun = async () => {
            await GetNotificationMes().then((response) => {
                setNotificationMes(response?.data?.dataList);
            })
        }
        NotificationMessageFun();
    }, [])


    useEffect(() => {

        notificationMes?.map((item) => {
            var user = notificationMes[0]?.roleName.split(" ");
            var dataList = user?.[0];
            var dataList2 = user?.[1];
            var listItem = dataList?.charAt(0)
            var listItem2 = dataList2?.charAt(0)
            setItemData(listItem)
            setItemLastData(listItem2)
        })

    }, [notificationMes])
    /************************** */
    const handelStartDate = async (event) => {
        setStartAuctionDate(dayjs(event).format("MM/DD/YYYY"))
    };
    const handelEndDate = async (event) => {
        setEndAuctionDate(dayjs(event).format("MM/DD/YYYY"))
    };
    useEffect(() => {
        if (startAuctionDate && endAuctionDate) {

            const AuctionFilter = async () => {
                await SubscriptionDataFilterByDate(startAuctionDate, endAuctionDate).then((response) => {

                    setDataSubscription(response?.data?.[0]);

                });
            };
            AuctionFilter();

            const SubscriptionRevnueCount = async () => {
                await GetSubscriptionCount(startAuctionDate, endAuctionDate).then((response) => {

                    setSubscriptionCount(response?.data)

                });
            };
            SubscriptionRevnueCount();

        }
    }, [startAuctionDate, endAuctionDate])

    let today = new Date();
    let oneYearEarlier = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
    let oneYearBefore = oneYearEarlier.toISOString().split('T')[0] + 'T00:00:00';

    return (
        <>

            <ToastContainer></ToastContainer>
            <TopNavbar sidebarfun={sidebarfun} />
            <div className="dasboard-group" >
                <Sidebar data={data} />
                <div className={data ? "dashboard-content full-contnet" : "dashboard-content"}>
                    <h1 className="heading-dash">Dashboard</h1>
                    <Row>
                        <Col >

                            <div className="sec-item">

                                <div className="item-sec">
                                    <h4><b>Registered Managers</b></h4>
                                    <Row>

                                        <Col>

                                            <div className="group-content">

                                                <div className="item-1">
                                                    <img src="../image/oragnization.svg" alt="Organization" width={35}></img>
                                                </div>
                                                <Link to="/WebAdmin/ViewOrganization" className="Link-to-page">
                                                    <div className="content ms-3">
                                                        <h2>{totalOrgData?.activeCount}</h2>
                                                        <p className="text-success">Active Accounts</p>
                                                    </div>
                                                </Link>
                                            </div>
                                            <div class="vl"></div>
                                        </Col>
                                        <Col>
                                            {totalOrgData?.expiredCount === 0 ?
                                                <div className="content">
                                                    <h2>{totalOrgData?.expiredCount}</h2>
                                                    <p className="text-danger">Inactive Accounts</p>
                                                </div>
                                                :
                                                <Link to="/WebAdmin/ViewOrganization" className="Link-to-page">
                                                    <div className="content">
                                                        <h2>{totalOrgData?.expiredCount}</h2>
                                                        <p className="text-danger">Inactive Accounts</p>
                                                    </div>
                                                </Link>
                                            }
                                        </Col>

                                    </Row>
                                </div>
                            </div>
                        </Col>

                        <Col >

                            <div className="sec-item">

                                <div className="item-sec">
                                    <h4><b>Registered Players</b></h4>
                                    <Row>

                                        <Col>

                                            <div className="group-content">

                                                <div className="item-2">
                                                    <img src="../image/user.svg" alt="user" width={35}></img>
                                                </div>
                                                <Link to="/WebAdmin/User" className="Link-to-page">
                                                    <div className="content ms-3">
                                                        <h2>{totalUserData?.activeCount}</h2>
                                                        <p className="text-success">Active Accounts</p>
                                                    </div>
                                                </Link>
                                            </div>
                                            <div class="vl"></div>
                                        </Col>
                                        <Col>
                                            <Link to="/WebAdmin/UserInactive" className="Link-to-page">
                                                <div className="content">
                                                    <h2>{totalUserData?.expiredCount}</h2>
                                                    <p className="text-danger">Inactive Accounts</p>

                                                </div>
                                            </Link>
                                        </Col>

                                    </Row>
                                </div>
                            </div>
                        </Col>

                    </Row>

                    <div className="group-card">

                    </div>

                    <Row>
                        <Col md="6"  >
                            <Card className="orgnization-sec Recent-manager">
                                <Row>
                                    <Col md="6" xs="6">   <h2>Recent Added Managers</h2>

                                    </Col>
                                    <Col md="6" xs="6"><p className="text-right"> <Link to="/WebAdmin/ViewOrganization" className='view-List'>View All</Link></p></Col>
                                    <Col md="12 orgnization-table">
                                        <Table responsive>
                                            <thead>
                                                <tr>
                                                    <th>Frist Name</th>
                                                    <th>Last Name</th>
                                                    <th>Email</th>
                                                    <th>Company Name</th>


                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    apiData?.map((item, index) =>

                                                        <tr>
                                                            <td scope='col'>{item.firstName}</td>
                                                            <td scope='col'>{item.lastName}</td>
                                                            <td scope='col'>{item.emailId}</td>
                                                            <td scope='col'>{item.orgName}</td>


                                                        </tr>
                                                    )
                                                }

                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>

                            </Card>
                        </Col>
                        <Col md="6" className="revenue-sec-mob" >
                            <Card className="revenue-sec">
                                <h2>Subscription Revenue</h2>

                                <Tabs
                                    defaultActiveKey="profile"
                                    id="justify-tab-example"
                                    className="mb-3"
                                    justify
                                    activeKey={key}
                                    onSelect={(k) => setKey(k)}
                                >

                                    <Tab eventKey="Amount" title="Amount">



                                        <Row>
                                            <Col md={12} lg={5}>


                                                <div className="group-sec">
                                                    {key === 'Amount' && (
                                                        <DoughnutChart monthly={dataSubscription?.monthlySubscriptionRevenue} yearly={dataSubscription?.yearlySubscriptionRevenue} today={dataSubscription?.dailySubscriptionRevenue} />
                                                    )}


                                                    <div className="total amount">
                                                        Total
                                                        <div className="amount-text">
                                                            {dataSubscription?.totalSubscriptionRevenue}
                                                        </div>
                                                    </div>

                                                </div>



                                            </Col>
                                            <Col md={12} lg={7}>
                                                <div>

                                                    <Row>
                                                        <Col>


                                                            <Form.Group>
                                                                <Form.Label>From</Form.Label>
                                                                <DatePicker
                                                                    placeholder="Start Date"
                                                                    format="MM/dd/yyyy hh:mm:ss aa"
                                                                    showMeridian
                                                                    name="startDate"
                                                                    className='Auction-Date'
                                                                    onChange={handelStartDate}
                                                                    required
                                                                    defaultValue={new Date(oneYearBefore)} // Set to midnight UTC
                                                                />
                                                                <Form.Control.Feedback type="invalid">
                                                                    Please enter Auction Start Date.
                                                                </Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>To</Form.Label>
                                                                <DatePicker placeholder="End Date" format="MM/dd/yyyy hh:mm:ss aa" showMeridian name="endDate" className=' Auction-Date' onChange={handelEndDate} required defaultValue={new Date()} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    Please enter Auction End Date.
                                                                </Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <h6 className="mt-3"><b>Amount</b></h6>

                                                    <>
                                                        <Col className='mt-3'><div className='d-flex mb-3'><div className='list-circle-pro  me-2'></div><p className='text-color-tab'>Today: {dataSubscription?.dailySubscriptionRevenue}</p></div></Col>
                                                        <Col className='mt-3'><div className='d-flex mb-3'><div className='list-circle me-2'></div> <p className='text-color-tab'>Monthly:{dataSubscription?.monthlySubscriptionRevenue}</p></div></Col>

                                                        <Col className='mt-3'><div className='d-flex mb-3'><div className='list-circle-up  me-2'></div><p className='text-color-tab'> Yearly: {dataSubscription?.yearlySubscriptionRevenue}</p></div></Col>
                                                        <Col> <div className="total amount des">
                                                            <h3>Total Amount: {dataSubscription?.totalSubscriptionRevenue}</h3>

                                                        </div></Col>
                                                    </>


                                                </div>
                                            </Col>
                                        </Row>

                                    </Tab>





                                    <Tab eventKey="Count" title="Count">

                                        <Row>
                                            <Col md={12} lg={5}>

                                                <div className="group-sec">
                                                    {key === 'Count' && (
                                                        <DoughnutChart2 monthly={subscriptionCount?.monthlySubscriptionCount} yearly={subscriptionCount?.yearlySubscriptionCount} today={subscriptionCount?.dailySubscriptionCount} />
                                                    )}



                                                    <div className="total Count desktop mob">
                                                        Total
                                                        <div className="Count-text">
                                                            {subscriptionCount?.totalSubscriptionCount}
                                                        </div>
                                                    </div>

                                                </div>
                                            </Col>
                                            <Col md={12} lg={7}>
                                                <div >

                                                    <Row>
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>From-</Form.Label>
                                                                <DatePicker placeholder="Start Date" format="MM/dd/yyyy HH:mm aa" name="startDate" className=' Auction-Date' onChange={handelStartDate} required defaultValue={new Date('2024-01-01')} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    Please enter Auction Start Date.
                                                                </Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>To-</Form.Label>
                                                                <DatePicker placeholder="End Date" format="MM/dd/yyyy" name="endDate" className=' Auction-Date To' onChange={handelEndDate} required defaultValue={new Date()} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    Please enter Auction End Date.
                                                                </Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    <h6 className="mt-3"><b>Count</b></h6>

                                                    <>
                                                        <Col className='mt-3'><div className='d-flex mb-3'><div className='list-circle-pro  me-2'></div><p className='text-color-tab'>Today: {subscriptionCount?.dailySubscriptionCount}</p></div></Col>
                                                        <Col className='mt-3'><div className='d-flex mb-3'><div className='list-circle me-2'></div> <p className='text-color-tab'>Monthly:{subscriptionCount?.monthlySubscriptionCount}</p></div></Col>

                                                        <Col className='mt-3'><div className='d-flex mb-3'><div className='list-circle-up  me-2'></div><p className='text-color-tab'> Yearly: {subscriptionCount?.yearlySubscriptionCount}</p></div></Col>

                                                        <Col>
                                                            <div className="total Count des">
                                                                <h3>   Total Count:  {subscriptionCount?.totalSubscriptionCount}</h3>

                                                            </div>

                                                        </Col>

                                                    </>

                                                </div>
                                            </Col>
                                        </Row>
                                    </Tab>
                                </Tabs>
                            </Card>
                        </Col>

                    </Row>
                    <Row>
                        <Col md="6" >
                            <Card className="orgnization-sec Invoice">
                                <Row>
                                    <Col md="6" xs="6">    <h2>Recent Invoice List</h2>

                                    </Col>

                                </Row>
                                <div className=" bid-table">
                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                <th>Invoice no.</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Address</th>
                                                <th>Plan Type </th>
                                                <th>Amount</th>
                                                <th>User Type</th>
                                                <th>Status </th>
                                                <th>Date </th>

                                            </tr>
                                        </thead>
                                        <tbody>

                                            {apiDataInvoice?.slice(0, 2).map((item, index) => {
                                                const convertUTCToLocalTime = (utcDateString) => {
                                                    const date = new Date(utcDateString);
                                                    return date.toLocaleString();
                                                };
                                                const localTime = convertUTCToLocalTime(item?.paymentDate + "Z");
                                                const [datePart, timePart] = localTime.split(", ");
                                                return (
                                                    <>
                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td>{item?.name}</td>
                                                            <td>{item?.emailId}</td>
                                                            <td>{item?.address}</td>
                                                            <td>{item?.planType}</td>
                                                            <td><b>{item?.amount}</b></td>
                                                            <td>{item?.userType}</td>
                                                            <td><span class="bg-succ">{item?.status}</span></td>
                                                            <td className="payment-date">{dayjs(item?.paymentDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</td>

                                                        </tr>
                                                    </>
                                                );
                                            })}
                                        </tbody>
                                    </Table>

                                </div>
                            </Card>

                        </Col>
                        <Col md="6">
                            <Card className="revenue-sec card notification-admin">
                                <Row>
                                    <Col md="6" xs="6">  <h2>Notifications</h2>
                                    </Col>
                                    <Col md="6" xs="6"><p className="text-right"> <Link to="/WebAdmin/Admin_notification" className='view-List'>View All</Link></p></Col>
                                </Row>

                                {
                                    notificationMes == null ? (
                                        <div>No data found!</div>
                                    ) : (
                                        notificationMes.map((item) => {


                                            return (


                                                <div className="pt-3">
                                                    <div className=" ">
                                                        <Row>
                                                            <Col md={1}>
                                                                <div className="profile-pic2">
                                                                    {itemData} {itemLastData}

                                                                </div>
                                                            </Col>
                                                            <Col md={11}>
                                                                <div className="ms-3">
                                                                    <h1 className="notification-super">
                                                                        <h1 className="notification-super">{notificationMes[0]?.roleName} </h1> </h1>
                                                                    <div class="box">
                                                                        <div className="notification-text-mess">
                                                                            <p className="text-message-area">
                                                                                {item?.message}  </p></div>
                                                                    </div>

                                                                    <div className="mt-1 mb-2 text-right-date">

                                                                        {dayjs(item?.createDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}

                                                                    </div>

                                                                </div>
                                                            </Col>
                                                        </Row>


                                                    </div>
                                                </div>
                                            );
                                        })
                                    )
                                }

                            </Card>

                        </Col>
                    </Row>

                </div>
                <div className={data ? "footer" : "footer-content"}>
                    <Footer />
                </div>
            </div>

        </>
    )
}
export default Dashboard;

